import React from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'

const CtaBanner = props => {
  const [fadeInRef, isInView] = useInView({ triggerOnce: true })

  const { title = 'CTA Heading', link, button } = props

  return (
    <React.Fragment>
      <aside>
        <div
          ref={fadeInRef}
          className={` ${
            isInView ? 'fade-in' : ''
          } animation cta-banner d-flex flex-column justify-content-center align-items-center`}
        >
          {/*animate*/}
          <h2 className='heading1'>{title}</h2>
          {link ? (
            props.noSlug ? (
              <p className='cta-banner__link'>
                <a href={link} className='link' target='_self'>
                  {button}
                </a>
              </p>
            ) : (
              <p className='cta-banner__link'>
                <Link href={link} passHref>
                  <a className='link' target='_self'>
                    {button}
                  </a>
                </Link>
              </p>
            )
          ) : (
            ''
          )}
        </div>
      </aside>
    </React.Fragment>
  )
}

export default CtaBanner
